import { AUTH_RESET, AUTH_SAVE } from "../actions/constant";

const INIT_STATE = {
  username: '',
  token: '',
  isVerified: false,
  isRegistered: false,
  otpPass: false,
  userLoggedin: null
};

const reducerFunc = (state = INIT_STATE, action) => {
  switch (action.type) {
    case AUTH_SAVE: {
      return {
        ...state,
        ...action.payload
      }
    }

    case AUTH_RESET: {
      return INIT_STATE
    }

    default: {
      return state;
    }
  }
};

export default reducerFunc;
